export default __webpack_public_path__ + "4c03310c84e42299d67866b9ba736ff1.jpg";